import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const GestionAlmacenApi = () => {
    const [cargando, setCargando] = useState(false);

    const getAlmacenDetalle = async (almacenInventarioId) => {
        try {
            setCargando(true);
            const response = await api.get(
                `almacen_inventario/detalle_almacen/${almacenInventarioId}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getAnalisisDRC = async (almacenInventarioId) => {
        try {
            setCargando(true);
            const response = await api.get(
                `analisis_drc_inventario/analisis_drc_almacen/${almacenInventarioId}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getMovimientoFromRecepcion = async (params) => {
        const endpoint = `movimientos_inventario/buscar_movimiento_desde_ingreso`;

        try {
            setCargando(true);
            const response = await api.get(endpoint, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getMovimientosNoTrasladados = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                `movimientos_inventario/movimientos_no_trasladados`,
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const solicitarAnalisisDRC = async (inventario_almacen_id, data) => {
        try {
            setCargando(true);
            const response = await api.post(
                `analisis_drc_inventario/solicitar_analisis_drc/${inventario_almacen_id}`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarAnalisisDRC = async (analisis_id, data) => {
        try {
            setCargando(true);
            const response = await api.patch(
                `analisis_drc_inventario/actualizar_analisis_drc/${analisis_id}`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const guardarGestionAlmacen = async (inventario_almacen_id, data) => {
        try {
            setCargando(true);
            const response = await api.post(
                `almacen_inventario/guardar_gestion_almacen/${inventario_almacen_id}`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const resolicitarAnalisisDRC = async (inventario_almacen_id, data) => {
        try {
            setCargando(true);
            const response = await api.post(
                `analisis_drc_inventario/resolicitar_analisis_drc/${inventario_almacen_id}`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getAlmacenDetalle,
        getAnalisisDRC,
        getMovimientoFromRecepcion,
        getMovimientosNoTrasladados,

        solicitarAnalisisDRC,
        actualizarAnalisisDRC,
        resolicitarAnalisisDRC,
        guardarGestionAlmacen,

        cargando,
    };
};
